<template>
  
  <div class="content-box">
    <!-- 타이틀 영역 -->
    <HconTitle subTitle="회원가입" subDescription="Hcon에서만 만날 수 있는 다양한 기업 전용 혜택을 제공합니다." />
    <!-- // 타이틀 영역 -->
    <div class="box-wrap">
      <h3 class="check-title">
        <!-- icon-check에 on 클래스 추가/제거시 사업자 인증과 사업자 인증 직접 입력으로 화면 변경 -->
        <span class="text-red">[필수]</span> 사업자 인증<span :class="spanClass"></span>
      </h3>
      <!-- 사업자 인증 -->
      <div class="outline-box" v-if="isShowMain">
        <fieldset>
          <legend>사업자 인증 필드 영역입니다.</legend>
          <div class="form-box">
            <div class="form-group row" :class="{'error': isBusinessNameError}">
              <HconInput type="text" ref="inputBzcoNmRef" v-model="inputBzcoNm" label="상호(회사명)" :hide-label="false" inputClass="md" placeholder="회사명을 입력하세요"  />
            </div>
            <p v-if="isBusinessNameError" class="helper-text error mt0">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "상호(회사명)를", "입력")}}</p>
          </div>
          <div class="form-box">
            <div class="form-group row" :class="{'error': isCeoNameError}">
              <HconInput type="text" ref="inputRpsrNmRef" v-model="inputRpsrNm" label="대표자명" :hide-label="false" inputClass="md" placeholder="대표자명을 입력해주세요"  />
            </div>
            <p v-if="isCeoNameError" class="helper-text error mt0">{{HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9031)}}</p>
          </div>
          <div class="form-box">
            <div class="form-group row" :class="{'error': isBusinessNoError}">
              <HconInput type="business" ref="inputBzrnRef" v-model="inputBzrn" label="사업자등록번호" :hide-label="false" inputClass="md" placeholder="하이픈(-) 없이 10자리 숫자를 입력하세요" buttonClass="btn-gray md" :showButton="true" buttonText="인증하기" @button-click="checkBzno()"/>
            </div>
            <p v-if="(isBusinessNoErrorInput && isBusinessNoErrorInputType == 'null')" class="helper-text error mt0">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "사업자등록번호를", "입력")}}</p>
            <p v-if="(isBusinessNoError10 && isBusinessNoError10Type == 'null')" class="helper-text error mt0">{{HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9028)}}</p>
            <p v-if="(isBusinessNoErrorNum && isBusinessNoErrorNumType == 'null')" class="helper-text error mt0">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9003, "", "숫자")}}</p>
            <p v-if="(isBusinessNoErrorCrtf && isBusinessNoErrorCrtfType == 'null')" class="helper-text error mt0">{{HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9029)}}</p>
            <p v-if="(isBusinessNoErrorOver && isBusinessNoErrorOverType == 'null')" class="helper-text error mt0">{{HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9030)}}</p> 
            <p class="helper-text">
              * 상호(회사명), 사업자등록번호, 대표자명을 입력 후 [인증하기]를 클릭하여 인증을 진행해주세요.
            </p>
          </div>
          <div class="button-box">
    </div>
          <div class="form-box">
            <div class="form-group row" :class="{'error': isBusinessndustryError || isBusinessnNmIndustryNmError}">
              <label for="" class="inp-label">업태/종목</label>
              <div class="col2">
                <div class="col" :class="{'error': isBusinessError}">
                  <HconDropDown type="dropdownBox" v-model="dropDownBizc" defaultLabel="업태 선택" class="md" selectBoxTitleClass="md wd301" :dropdownOptions= "bizcList" />
                  <div class="form-group mt10" v-if="isShowBizc">
                    <HconInput type="text" ref="inputBizcRef" v-model="inputBizc" label="업태 직접입력" :hide-label="true" inputClass="md" placeholder="업태 직접입력"/>
                  </div>
                  <p v-if="(isBusinessError && isBusinessErrorType == 'null') && (dropDownBizc == null || dropDownBizc =='')" class="helper-text error mt0">
                    {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "업태를", "선택")}}
                  </p>
                  <p v-if="(isBusinessError && isBusinessErrorType == 'null') && (inputBizc == null || inputBizc =='')" class="helper-text error">
                        {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"업태를","입력")}}
                  </p>
                </div>
                <div class="col" :class="{'error': isIndustryError}">
                  <HconDropDown type="dropdownBox" v-model="dropDownBiztp" defaultLabel="종목 선택" class="md" selectBoxTitleClass="md wd301" :dropdownOptions= "biztpList"/>
                  <div class="form-group mt10"v-if="isShowBiztp">
                    <HconInput type="text" ref="inputBiztpRef" v-model="inputBiztp" label="종목 직접입력" :hide-label="true" inputClass="md" placeholder="종목 직접입력"/>
                  </div>
                  <p v-if="(isIndustryError && isIndustryErrorType == 'null') && (dropDownBiztp == null || dropDownBiztp =='')" class="helper-text error mt0">
                    {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "종목을", "선택")}}
                  </p>
                  <p v-if="(isIndustryError && isIndustryErrorType == 'null') && (inputBiztp == null || inputBiztp =='')" class="helper-text error">
                        {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"종목을","입력")}}
                  </p>
                </div>
              </div>
            </div>
            <p v-if="(isBusinessndustryError && isBusinessndustryErrorType == 'null')" class="helper-text error mt0">
              {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"업태와 종목을 모두","선택")}}
            </p>
            <p v-if="isBusinessnNmIndustryNmError && isBusinessnNmIndustryNmErrorType == 'null'" class="helper-text error mt0">
              {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"업태와 종목을 모두","입력")}}
            </p>
            <p class="helper-text" v-if="isShowBizc && isShowBiztp">
              * 업태 및 종목을 직접입력 하세요.
            </p>
          </div>
          <div class="form-box">
            <div class="form-group row" :class="{'error': isBusinessAdressError}">
              <HconInput type="text" ref="inputBzcoAdrRef" v-model="inputBzcoAdr" label="사업장 주소" :hide-label="false" inputClass="md" placeholder="사업장 주소를 입력해주세요"/>
            </div>
            <p v-if="isBusinessAdressError" class="helper-text error mt0">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "사업장 주소를", "입력")}}</p>
          </div>
        </fieldset>
        <div class="box-gray">
          <p class="icon-info">
            사업자 정보를 도용하여 회원가입 또는 결제 등의 행위를 하는
            경우 그에 따른 법적 조치가 취해질 수 있음을 알려드립니다.
            (형법 제347조의2의 컴퓨터 등 사용사기,
            <span class="text-red"
              >형법 제233조의2의 전자기록위작·변작죄, 형법 제234조의
              위조사문서등행사죄)</span
            >
          </p>
        </div>
      </div>      
      <!-- // 사업자 인증 -->
      <!-- 사업자 인증 직접 입력 -->
      <div class="outline-box" v-if="isShowMain2">
        <fieldset>
          <legend class="a11y-blind">
            사업자 인증 직접 입력 필드 영역입니다.
          </legend>
          <div class="form-box">
            <div class="form-group row" :class="{'error': isBusinessNameError}">
              <HconInput type="text" ref="inputBzcoNm2Ref" v-model="inputBzcoNm2" label="상호(회사명)" :hide-label="false" inputClass="md" placeholder="회사명을 입력하세요"/>
            </div>
            <p v-if="isBusinessNameError" class="helper-text error mt0">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "상호(회사명)를", "입력")}}</p>
          </div>
          <div class="form-box">
            <div class="form-group row" :class="{'error': isCeoNameError}">
              <HconInput type="text" ref="inputRpsrNm2Ref" v-model="inputRpsrNm2" label="대표자명" :hide-label="false" inputClass="md" placeholder="대표자명을 입력하세요"/>
            </div>
            <p v-if="(isCeoNameError && isCeoNameErrorType == 'null')" class="helper-text error mt0">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "대표자명을", "입력")}}</p>
          </div>
          <div class="form-box">
            <div class="form-group row" :class="{'error': isBusinessNoError}">
              <HconInput type="business" ref="inputBzrn2Ref" v-model="inputBzrn2" label="사업자등록번호" :hide-label="false" inputClass="md" placeholder="하이픈(-) 없이 10자리 숫자를 입력하세요"/>
            </div>
            <p v-if="(isBusinessNoErrorInput && isBusinessNoErrorInputType == 'null')" class="helper-text error mt0">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "사업자등록번호를", "입력")}}</p>
            <p v-if="(isBusinessNoError10 && isBusinessNoError10Type == 'null')" class="helper-text error mt0">{{HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9028)}}</p>
            <p v-if="(isBusinessNoErrorNum && isBusinessNoErrorNumType == 'null')" class="helper-text error mt0">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9003, "", "숫자")}}</p>
            <p v-if="(isBusinessNoErrorCrtf && isBusinessNoErrorCrtfType == 'null')" class="helper-text error mt0">{{HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9029)}}</p>
            <p v-if="(isBusinessNoErrorOver && isBusinessNoErrorOverType == 'null')" class="helper-text error mt0">{{HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9030)}}</p> 
            <p class="helper-text">* 사업자등록번호를 직접 입력합니다.</p>
          </div>
          <div class="form-box">
            <div class="form-group row" :class="{'error': isBusinessFileError}">
              <HconComPCUpload 
                    :token-provider="`/api/v1/common/create-upload-token/bzco/2048/1`"
                    :uploaded="bzcoRgcrt"
                    @change="onChangeBzcoRgcrt"         
                    label="사업자등록증 사본" 
                    :hide-label="false" 
                    inputClass="md" 
                    buttonClass="btn-outline md" 
                    :showButton="true" 
                    buttonText="파일찾기"
                    :chkAcceptType="['png','jpg', 'pdf']"
                    :placeholder="filePlaceholder"
                />
            </div>
            <p v-if="(isBusinessFileErrorInput && isBusinessFileErrorInputType == 'null')" class="helper-text error mt0">{{HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9006, "사업자등록증")}}</p>
            <p v-if="(isBusinessFileErrorPattern && isBusinessFileErrorPatternType == 'null')" class="helper-text error mt0">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9007, "png, jpg, pdf", "2MB")}}</p>
          </div>
          <div class="form-box">
            <div class="form-group row" :class="{'error': isBusinessndustryError || isBusinessnNmIndustryNmError}">
              <label for="" class="inp-label">업태/종목</label>
              <div class="col2">
                <div class="col" :class="{'error': isBusinessError}">
                  <HconDropDown type="dropdownBox" v-model="dropDownBizc2" defaultLabel="업태 선택" class="md" selectBoxTitleClass="md wd301" :dropdownOptions= "bizcList" />
                  <div class="form-group mt10" v-if="isShowBizc2">
                    <HconInput type="text" ref="inputBizc2Ref" v-model="inputBizc2" label="업태 직접입력" :hide-label="true" inputClass="md" placeholder="업태 직접입력"/>
                  </div>
                  <p v-if="(isBusinessError && isBusinessErrorType == 'null') && (dropDownBizc == null || dropDownBizc =='')" class="helper-text error mt0">
                    {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "업태를", "선택")}}
                  </p>
                  <p v-if="(isBusinessError && isBusinessErrorType == 'null') && (inputBizc == null || inputBizc =='')" class="helper-text error">
                        {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"업태를","입력")}}
                  </p>                </div>
                <div class="col" :class="{'error': isIndustryError}">
                  <HconDropDown type="dropdownBox" v-model="dropDownBiztp2" defaultLabel="종목 선택" class="md" selectBoxTitleClass="md wd301" :dropdownOptions= "biztpList" />
                  <div class="form-group mt10" v-if="isShowBiztp2">
                    <HconInput type="text" ref="inputBiztp2Ref" v-model="inputBiztp2" label="종목 직접입력" :hide-label="true" inputClass="md" placeholder="종목 직접입력"/>
                  </div>
                  <p v-if="(isIndustryError && isIndustryErrorType == 'null') && (dropDownBiztp == null || dropDownBiztp =='')" class="helper-text error mt0">
                    {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "종목을", "선택")}}
                  </p>
                  <p v-if="(isIndustryError && isIndustryErrorType == 'null') && (inputBiztp == null || inputBiztp =='')" class="helper-text error">
                        {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"종목을","입력")}}
                  </p>                
                </div>
              </div>
            </div>
            <p v-if="isBusinessBothError" class="helper-text error mt0">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "업태와 종목을", "선택")}}</p>
            <p v-if="(isBusinessndustryError && isBusinessndustryErrorType == 'null')" class="helper-text error mt0">
              {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"업태와 종목을 모두","선택")}}
            </p>
            <p v-if="isBusinessnNmIndustryNmError && isBusinessnNmIndustryNmErrorType == 'null'" class="helper-text error mt0">
              {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"업태와 종목을 모두","입력")}}
            </p>          
            <p class="helper-text" v-if="isShowBizc && isShowBiztp">
              * 업태 및 종목을 직접입력 하세요.
            </p>
          </div>
          <div class="form-box">
            <div class="form-group row" :class="{'error': isBusinessAdressError}">
              <HconInput type="text" ref="inputBzcoAdr2Ref" v-model="inputBzcoAdr2" label="사업장 주소" :hide-label="false" inputClass="md" placeholder="사업장 주소를 입력하세요"/>
            </div>
            <p v-if="(isBusinessAdressError && isBusinessAdressErrorType == 'null')" class="helper-text error mt0">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "사업장 주소를", "입력")}}</p>
          </div>
        </fieldset>
        <div class="box-gray">
          <p class="icon-info">
            사업자등록번호를 직접 입력하실 경우 회원가입 후
            <span class="text-red">Hcon 관리자가 승인</span> 처리 시
            가입이 완료됩니다. 승인 처리는
            <span class="text-red">영업일 기준 1일 이내</span>에
            완료되며 회원가입 완료 안내 메일이 전송됩니다.
            사업자등록증사본 사업자등록번호를 도용하는 경우 형사 처벌의
            대상이 됩니다. 파일은 png, jpg, pdf 형식의 2MB이하로
            등록하시기 바랍니다.
          </p>
        </div>
        <div class="quick-box">
          <p>사업자 정보 빠르게 입력하고 싶으시다면?</p>
          <button type="button" class="btn btn-outline md" @:click="changeShow">사업자 등록번호 인증하기</button>
        </div>
      </div>
      <!-- // 사업자 인증 직접 입력 -->
    </div>
    <!-- 회원정보 입력 -->
    <div class="box-wrap">
      <h3 class="check-title">
        <span class="text-red">[필수]</span> 회원정보 입력<span :class="spanClass2"></span>
      </h3>
      <div class="outline-box">
        <fieldset>
          <legend class="a11y-blind">
            회원정보 입력 필드 영역입니다.
          </legend>
          <div class="form-box">
            <div class="form-group row" :class="{'error': isIdError}">
              <HconInput type="text" label="아이디" ref="inputIdRef" v-model="inputId" :hide-label="false" inputClass="md" buttonClass="btn-gray md" :showButton="true" buttonText="중복확인" placeholder="아이디 입력 후 중복확인을 진행해주세요" 
              @button-click="checkDuplicatedMemberInfo('id')"/>
            </div>
            <p v-if="(isIdErrorInput && isIdErrorInputType == 'null')" class="helper-text error mt0">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "아이디를", "입력")}}</p>
            <p v-if="(isIdErrorPattern && isIdErrorPatternType == 'null')" class="helper-text error mt0">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9008, "아이디")}}</p>
            <p v-if="(isIdErrorCrtf && isIdErrorCrtfType == 'null')" class="helper-text error mt0">{{HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9013)}}</p>
            <p class="helper-text">
              * 아이디는 영문 소문자와 숫자만 사용할 수 있습니다
            </p>
          </div>
          <div class="form-box">
            <div class="form-group row" :class="{'error': isPwError}">
              <HconInput type="password" ref="inputPasswordRef" v-model="inputPassword" label="비밀번호" :hide-label="false" inputClass="md" placeholder="비밀번호를 입력해주세요"/>
            </div>
            <p v-if="isPwErrorInput && isPwErrorInputType == 'null'" class="helper-text error mt0">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "비밀번호를", "입력")}}</p>
            <p v-if="isPwErrorPattern && isPwErrorPatternType == 'null'" class="helper-text error mt0">{{HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9020)}}</p>
            <p v-if="isPwError3 && isPwError3Type == 'null'" class="helper-text error mt0">{{HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9021)}}</p>
            <p class="helper-text">
              * 영문, 숫자, 특수문자 포함으로 9~20자리로 입력해주세요
            </p>
          </div>
          <div class="form-box">
            <div class="form-group row" :class="{'error': isPwConfirmError}">
              <HconInput type="password" ref="inputPasswordCheckRef" v-model="inputPasswordCheck" label="비밀번호 확인" :hide-label="false" inputClass="md" placeholder="비밀번호를 다시 입력해주세요" />
            </div>
            <p v-if="isPwErrorCheckInput && isPwErrorCheckInputType == 'null'" class="helper-text error mt0">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "비밀번호 확인란을", "입력")}}</p>
            <p v-if="isPwConfirmError && isPwConfirmErrorType == 'null'" class="helper-text error mt0">{{HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9005,"입력하신 비밀번호가")}}</p>
            <p class="helper-text">
              * 입력하신 비밀번호와 동일하게 입력해주세요
            </p>
          </div>
          <div class="form-box">
            <div class="form-group row" :class="{'error': isTelError}">
              <HconInput type="text" ref="inputMblTelnoRef" v-model="inputMblTelno" label="휴대전화번호" :hide-label="false" inputClass="md" buttonClass="btn-gray md" :showButton="true" buttonText="인증하기" placeholder="휴대전화번호 인증 시 자동 입력" @button-click="checkMblTelno()" readonly />
            </div>
            <p v-if="isTelErrorInput && isTelErrorInputType == 'null'" class="helper-text error mt0">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "휴대전화번호를", "입력")}}</p>
            <p class="helper-text">* 휴대전화번호와 담당자명은 PASS 인증을 통해 확인되며 자동으로 입력됩니다.</p>
          </div>
          <div class="form-box">
            <div class="form-group row">
              <HconInput type="text" ref="inputChrgrNmRef" v-model="inputChrgrNm" label="담당자명" :hide-label="false" inputClass="md" placeholder="휴대전화번호 인증 시 자동 입력" disabled  />
            </div>
          </div>
          <div class="form-box">
            <div class="form-group row" :class="{'error': isEmailError}">
              <HconInput type="email" ref="inputEmlAdrRef" v-model="inputEmlAdr" label="이메일" :hide-label="false" inputClass="md" selectBoxTitleClass="md wd168" 
              buttonClass="btn-gray md" :showButton="true" buttonText="중복확인" @button-click="checkDuplicatedMemberInfo('email')" />
            </div>
            <p class="helper-text">
              * 견적서 발송, 포인트 이용 내역, 약관 변경 등 주요 안내
              메일 수신을 위해 사용됩니다.
            </p>
          </div>
          <div class="form-box">
            <div class="form-group row" :class="{'error': isDepartmentCompanyRankError || isDepartmentNmCompanyRankNmError}">
              <label for="" class="inp-label">근무부서/직급</label>
              <div class="col2">
                <div class="col" :class="{'error': isDepartmentError}">
                  <HconDropDown type="dropdownBox" v-model="dropDownDept" defaultLabel="근무부서 선택" class="md" selectBoxTitleClass="md wd301" :dropdown-options="deptList"/>
                  <div class="form-group mt10" v-if:="isShowDept">
                    <HconInput type="text" ref="inputDeptRef" v-model="inputDept" label="근무부서 직접입력" :hide-label="true" inputClass="md" placeholder="근무부서 직접입력"/>
                  </div>

                  <p v-if="(isDepartmentError && isDepartmentErrorType == 'null') && (dropDownDept == null || dropDownDept =='')" class="helper-text error">
                          {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"근무부서를","선택")}}
                        </p>
                        <p v-if="(isDepartmentNmError && isDepartmentNmErrorType == 'null') && (inputDept == null || inputDept =='')" class="helper-text error">
                          {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"근무부서 직접입력을","입력")}}
                        </p>
                  <p v-if="isDepartmentError" class="helper-text error mt0">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "근무부서를", "선택")}}</p>
                </div>
                <div class="col" :class="{'error': isCompanyRankError}">
                  <HconDropDown type="dropdownBox" v-model="dropDownJrsp" defaultLabel="직급 선택" class="md" selectBoxTitleClass="md wd301" :dropdown-options="jrspList" />
                  <div class="form-group mt10" v-if:="isShowJrsp ">
                    <HconInput type="text" ref="inputJrspRef" v-model="inputJrsp" label="직급 직접입력" :hide-label="true" inputClass="md" placeholder="직급 직접입력" />
                  </div>
                  <p v-if="(isCompanyRankError && isCompanyRankErrorType == 'null') && (dropDownJrsp == null || dropDownJrsp == '')" class="helper-text error">
                    {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"직급을","선택")}}
                  </p>
                  <p v-if="(isCompanyRankNmError && isCompanyRankNmErrorType == 'null') && (inputJrsp == null || inputJrsp == '')" class="helper-text error">
                    {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"직급 직접입력을","입력")}}
                  </p>                </div>
              </div>
            </div>
            <p v-if="(isDepartmentCompanyRankError && isDepartmentCompanyRankErrorType == 'null')" class="helper-text error">
              {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"근무부서와 직급을 모두","선택")}}
            </p>
            <p v-if="isDepartmentNmCompanyRankNmError && isDepartmentNmCompanyRankNmErrorType == 'null'" class="helper-text error">
              {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"근무부서와 직급 직접입력을 모두","입력")}}
            </p>            
            <p class="helper-text" v-if="isShowDeptJrspHelp">
              * 근무부서 및 직급을 직접입력 하세요.
            </p>
          </div>
          <div class="form-box">
            <div class="form-group row" :class="{'error': isLandlineTelError}">
              <HconInput type="tel" ref="inputCbleTelnoRef" v-model="inputCbleTelno" label="유선 전화번호" inputClass="md" selectBoxTitleClass="md wd198" :hide-label="false" />

              <!-- <HconInput 
                  type="telObj" 
                  label="유선 전화번호" 
                  v-model:tel-value="inputCbleTelno"
                  ref="inputCbleTelnoRef"
                  :showButton="false"
                  :inputOptions="hcAreaNoCd"
                  selectBoxTitleClass="wd198"
                  :hide-label="false" 
                  required />             -->
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    <!-- // 회원정보 입력 -->
    <!-- 약관동의 -->
    <div class="box-wrap">
      <h3 class="no-check-title">약관동의</h3>
      <div class="outline-box">
        <div class="term-box">
          <ul class="term-list">
            <li>
              <HconCheckBox type="default" :checked="checkBoxAllChecked =='Y' ? true : false" v-model="checkBoxAll" @change="checkBoxAllChanged" label="전체 동의합니다." name="checkBoxAll" labelClass="all-check-title" :hide-label="false" :showTextAfter="true" text="(선택사항 포함)" textClass="font-normal text-green" />
              <div class="box-gray mt25 mb16">
                <ul class="dot-list">
                  <li>
                    전체 동의에는 필수 정보와 선택 정보에 대한 동의가
                    모두 포함되며, 개별적으로도 동의를 선택할 수
                    있습니다.
                  </li>
                  <li>
                    선택 정보에는 마케팅
                    수신 동의(선택)가 포함됩니다.
                  </li>
                  <li>
                    선택 정보에 대한 동의를 거부하시더라도 Hcon 서비스
                    이용은 가능합니다.
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <div class="term-item">
                <div class="term-check-box">
                  <HconCheckBox type="default" :checked="checkBoxOver14Checked == 'Y' ? true : false" v-model="checkBoxOver14" @change="checkBoxOver14Changed" label="14세 이상입니다." name="checkBoxOver14" :showTextBefore="true" text="[필수]" textClass="text-red" labelClass="-title" :hide-label="false" />
                </div>
              </div>
            </li>
            <li>
              <div class="term-item">
                <div class="term-check-box">
                  <HconCheckBox type="default" :checked="checkBox1001Checked =='Y' ? true : false" v-model="checkBox1001" @change="checkBox1001Changed" label="서비스 이용약관" name="checkBox1001" :showTextBefore="true" text="[필수]" textClass="text-red" labelClass="-title" :hide-label="false" />
                  <button type="button" class="btn-detail" v-on:click="handlePopup(HcTncKndCd.KND_1001)">
                    내용보기
                  </button>
                </div>
              </div>
            </li>
            <li>
              <div class="term-item">
                <div class="term-check-box">
                  <HconCheckBox type="default" :checked="checkBox1006Checked =='Y' ? true : false" v-model="checkBox1006" @change="checkBox1006Changed" label="개인정보 수집 및 이용" name="checkBox1006" :showTextBefore="true" text="[필수]" textClass="text-red" labelClass="-title" :hide-label="false" />
                  <button type="button" class="btn-detail" v-on:click="handlePopup(HcTncKndCd.KND_1003)">
                    내용보기
                  </button>
                </div>
              </div>
            </li>
            <li>
              <div class="term-item">
                <div class="term-check-box">
                  <HconCheckBox type="default" :checked="checkBox1011Checked =='Y' ? true : false" v-model="checkBox1011" @change="checkBox1011Changed" label="마케팅 수신동의" name="checkBox1011" :showTextBefore="true" text="[선택]" textClass="text-green" labelClass="-title" :hide-label="false" />
                  <!-- <button type="button" class="btn-detail" v-on:click="showTermPop('1011')">
                    내용보기
                  </button> -->
                </div>
                <div class="term-info-box">
                  <p>
                    이벤트&쇼핑 정보를 선택하신 수단으로 전송합니다.
                  </p>
                  <div class="form-group row">
                    <HconCheckBox type="default" :checked="checkBoxSns1002Checked =='Y' ? true : false" v-model="checkBoxSns1002" @change="checkBoxSns1002Changed" label="문자알림" name="checkBoxSns1002" :hide-label="false" />
                    <HconCheckBox type="default" :checked="checkBoxSns1001Checked =='Y' ? true : false" v-model="checkBoxSns1001" @change="checkBoxSns1001Changed" label="알림톡" name="checkBoxSns1001" :hide-label="false" />
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- // 약관동의 -->
    <!-- 버튼 -->
    <div class="button-box">
      <button type="submit" class="btn lg" @click="isShowMain==false?uploadBzcoRgcrt():registMember()">회원가입</button>
    </div>
    <br/>
    <!-- // 버튼 -->
  </div>
  <HconLoading v-model="fetchLoading" />
  <HconTncInfoPopup v-if="tncInfoPopupOpen" :tncInfo="tncReq" @open="tncInfoPopupOpen = true" @close="tncInfoPopupOpen = false">
    <Terms1001 v-if="hcTncKndCd === HcTncKndCd.KND_1001" :isTermsPopupOpen="tncInfoPopupOpen"></Terms1001>
    <Terms1003 v-if="hcTncKndCd === HcTncKndCd.KND_1003" :isTermsPopupOpen="tncInfoPopupOpen"></Terms1003>
  </HconTncInfoPopup>
</template>
<script lang="ts" setup>
  definePageMeta({
      "require-auth" : true
  });

import HconTncInfoPopup from '@/components/popup/HconTncInfoPopup.vue'
import Terms1001 from '@/components/popup/terms/1001Terms.vue'
import Terms1003 from '@/components/popup/terms/1003Terms.vue'
import { HcTncUsePntmCd, HcTncKndCd } from '~/types/common/tnc-enum-types';
import HconTitle from '@/components/com/HconComPCTitle.vue'
import HconInput from '@/components/com/HconComPCInputField.vue'
import HconComPCUpload from '@/components/com/HconComPCUpload.vue'
import HconDropDown from '@/components/com/HconComPCDropDown.vue'
import HconCheckBox from '@/components/com/HconComPCCheckbox.vue'
import { CommonUtil } from '~/utils/common/common-utils'
import { usePopup } from '@/composables/hconUsePopup'
import { onMounted, watch } from 'vue'
import { COMMON_CODE, MEMBER_CODE } from '@/constants/hconMessageConstants'
import { HconCommonRegExp } from '@/constants/hconRegexConstants'
import HconLoading from '@/components/com/HconComPCLoading.vue';

// 약관 내용 팝업 변수 값
const tncInfoPopupOpen = ref(false);

// 약관종류코드
const hcTncKndCd = ref('')

// 약관 내용 팝업 요청 값
const tncReq = ref<any>({})

// 약관 내용 팝업 팝업 
const handlePopup = (value:any) => {
  tncInfoPopupOpen.value = true
  hcTncKndCd.value = value
  tncReq.value = {
    hcTncKndCd : value, // 1001: 서비스 이용약관 1003: 개인정보처리방침
    hcTncKndCdNm: hcTncKndCd.value === HcTncKndCd.KND_1001 ? 'Hcon 몰 서비스 이용약관' : hcTncKndCd.value === HcTncKndCd.KND_1003 ? '개인정보처리방침' : '',
    hcTncUsePntmCd: HcTncUsePntmCd.MEMBER_JOIN, // 회원가입
    customClass: hcTncKndCd.value === HcTncKndCd.KND_1001 ? 'custom-popup mx-wd1000 terms-ts' : hcTncKndCd.value === HcTncKndCd.KND_1003 ? 'custom-popup mx-wd1000 terms-pv' : 'custom-popup mx-wd1000'
  }
  
}

// DTO 준비
import type { BizcBiztpDto, MemberInfoDuplicateCheckDto } from '~/types/member/join/backend-dto-types';
import type { CodeDto, CommFileDto } from '~/types/common/backend-dto-types';

//사업자 인증 FORM(NICE)
const inputBzcoNm     = ref("")
const inputBzcoNmRef  = ref<InstanceType<typeof HconInput> | null>(null)
const inputBzrn       = ref("")
const inputBzrnRef    = ref<InstanceType<typeof HconInput> | null>(null)
const inputRpsrNm     = ref("")
const inputRpsrNmRef  = ref<InstanceType<typeof HconInput> | null>(null)
const inputBizc       = ref("")
const inputBizcRef    = ref<InstanceType<typeof HconInput> | null>(null)
const dropDownBizc    = ref("")
const inputBiztp      = ref("")
const inputBiztpRef   = ref<InstanceType<typeof HconInput> | null>(null)
const dropDownBiztp   = ref("")
const inputBzcoAdr    = ref("")
const inputBzcoAdrRef = ref<InstanceType<typeof HconInput> | null>(null)

const isShowMain           = ref(true)
const isShowBizc           = ref(false)
const isShowBiztp          = ref(false)
const isShowBizcBiztpHelp  = ref(false)

//사업자 인증 FORM(수기)
const inputBzcoNm2     = ref("")
const inputBzcoNm2Ref  = ref<InstanceType<typeof HconInput> | null>(null)
const inputBzrn2       = ref("")
const inputBzrn2Ref    = ref<InstanceType<typeof HconInput> | null>(null)
const inputRpsrNm2     = ref("")
const inputRpsrNm2Ref  = ref<InstanceType<typeof HconInput> | null>(null)
const inputBzcoRgcrt  = ref("")
const inputBzcoRgcrtRef  = ref<InstanceType<typeof HconInput> | null>(null)
const inputBizc2       = ref("")
const inputBizc2Ref    = ref<InstanceType<typeof HconInput> | null>(null)
const dropDownBizc2    = ref("")
const inputBiztp2      = ref("")
const inputBiztp2Ref   = ref<InstanceType<typeof HconInput> | null>(null)
const dropDownBiztp2   = ref("")
const inputBzcoAdr2    = ref("")
const inputBzcoAdr2Ref = ref<InstanceType<typeof HconInput> | null>(null)

const isShowMain2          = ref(false)
const isShowBizc2          = ref(false)
const isShowBiztp2         = ref(false)
const isShowBizcBiztpHelp2 = ref(false)

//회원정보 입력 FORM
const inputId               = ref("")
const inputIdRef            = ref<InstanceType<typeof HconInput> | null>(null)
const inputPassword         = ref("")
const inputPasswordRef      = ref<InstanceType<typeof HconInput> | null>(null)
const inputPasswordCheck    = ref("")
const inputPasswordCheckRef = ref<InstanceType<typeof HconInput> | null>(null)
const inputMblTelno         = ref("")
const inputMblTelnoRef      = ref<InstanceType<typeof HconInput> | null>(null)
const inputEncCi            = ref("")
const inputSelfCrtfGndrNval = ref(1)
const inputChrgrNm          = ref("")
const inputChrgrNmRef       = ref<InstanceType<typeof HconInput> | null>(null)
const inputEmlAdr           = ref("")
const inputEmlAdrRef        = ref<InstanceType<typeof HconInput> | null>(null)
const inputDept             = ref("")
const inputDeptRef          = ref<InstanceType<typeof HconInput> | null>(null)
const dropDownDept          = ref("")
const inputJrsp             = ref("")
const inputJrspRef          = ref<InstanceType<typeof HconInput> | null>(null)
const dropDownJrsp          = ref("")
const inputCbleTelno          = ref("")
const inputBirth          = ref("")
// const inputCbleTelno        = {
//   areaCode: "",
//   customAreaCode: "",
//   mid: "",
//   last: ""
// }
// const inputCbleTelno = ref({
//   areaCode: '',
//   customAreaCode: '',
//   mid: '',
//   last: '',
// });
const inputCbleTelnoRef      = ref<InstanceType<typeof HconInput> | null>(null)

const isShowDept          = ref(false)
const isShowJrsp          = ref(false)
const isShowDeptJrspHelp  = ref(false)

//약관동의
const checkBoxAll           = ref("")
const checkBoxOver14        = ref("")
const checkBox1001          = ref("")
const checkBox1006          = ref("")
const checkBox1011          = ref("")
const checkBoxSns1001             = ref("")
const checkBoxSns1002             = ref("")
const checkBoxAllChecked    = ref("N")
const checkBoxOver14Checked = ref("N")
const checkBox1001Checked   = ref("N")
const checkBox1006Checked   = ref("N")
const checkBox1011Checked   = ref("N")
const checkBoxSns1001Checked   = ref("N")
const checkBoxSns1002Checked   = ref("N")

const spanClass           = ref("icon-check off")
const spanClass2           = ref("icon-check off")
const bizcList            = reactive<any[]>([])
const biztpList           = reactive<any[]>([])
const deptList            = reactive<any[]>([])
const jrspList            = reactive<any[]>([])         
const areaNoList            = reactive<any[]>([])         
const tncList = ref<any>([]);
// HCON지역번호코드
const {codeDataList:hcAreaNoCd, isLoading: isLoadingCbleTelno} = useHconRefCommonCode('hc_area_no_cd');

const checkBznoFlag       = ref(false)
const checkMblTelnoFlag   = ref(false)
const duplicatedIdFlag    = ref(false)
const duplicatedEmailFlag = ref(false) 
const fileUploadFlag      = ref(false)

const atchFilePath = ref("")
const fetchLoading        = ref(false)
const fetchBuilder        = useHconFetchBuilder();

const tncNo1001 = ref("")
const tncNo1006 = ref("")
const tncNo1011 = ref("")
const tncNo1012 = ref("")

const filePlaceholder = ref("파일은 png, jpg, pdf 형식의 2MB 이하로 등록하시기 바랍니다")

const bzcoRgcrt = ref<CommonFile[]>();

const isBusinessNameError             = ref(false)
const isBusinessNoError               = ref(false)
const isBusinessNoErrorInput          = ref(false)
const isBusinessNoError10             = ref(false)
const isBusinessNoErrorNum            = ref(false)
const isBusinessNoErrorCrtf           = ref(false)
const isBusinessNoErrorOver           = ref(false)
const isCeoNameError                  = ref(false)
const isBusinessBothError             = ref(false)
const isBusinessndustryError          = ref(false)
const isBusinessnNmIndustryNmError    = ref(false)
const isBusinessError                 = ref(false)
const isIndustryError                 = ref(false)
const isBusinessFileError             = ref(false)
const isBusinessFileErrorInput        = ref(false)
const isBusinessFileErrorPattern      = ref(false)
const isBusinessAdressError           = ref(false)
const isIdError                       = ref(false)
const isIdErrorInput                  = ref(false)
const isIdErrorPattern                = ref(false)
const isIdErrorCrtf                   = ref(false)
const isPwError                       = ref(false)
const isPwErrorInput                  = ref(false)
const isPwErrorCheckInput             = ref(false)
const isPwErrorPattern                = ref(false)
const isPwError3                      = ref(false)
const isPwConfirmError                = ref(false)
const isTelError                      = ref(false)
const isTelErrorInput                 = ref(false)
const isEmailError                    = ref(false)
const isDepartmentError               = ref(false)
const isDepartmentNmError             = ref(false)
const isCompanyRankError              = ref(false)
const isCompanyRankNmError            = ref(false)
const isDepartmentCompanyRankError    = ref(false)
const isDepartmentNmCompanyRankNmError= ref(false)
const isLandlineTelError              = ref(false)

const isBusinessNoErrorInputType          = ref("")
const isBusinessNoError10Type             = ref("")
const isBusinessNoErrorNumType            = ref("")
const isBusinessNoErrorCrtfType           = ref("")
const isBusinessNoErrorOverType           = ref("")
const isCeoNameErrorType                  = ref("")
const isBusinessndustryErrorType          = ref("")
const isBusinessnNmIndustryNmErrorType    = ref("")
const isBusinessErrorType                 = ref("")
const isIndustryErrorType                 = ref("")
const isBusinessFileErrorInputType        = ref("")
const isBusinessFileErrorPatternType      = ref("")
const isBusinessAdressErrorType           = ref("")
const isIdErrorInputType                  = ref("")
const isIdErrorPatternType                = ref("")
const isIdErrorCrtfType                   = ref("")
const isPwErrorInputType                  = ref("")
const isPwErrorCheckInputType             = ref("")
const isPwErrorPatternType                = ref("")
const isPwError3Type                      = ref("")
const isPwConfirmErrorType                = ref("")
const isDepartmentErrorType               = ref("")
const isDepartmentNmErrorType             = ref("")
const isCompanyRankErrorType              = ref("")
const isCompanyRankNmErrorType            = ref("")
const isDepartmentCompanyRankErrorType    = ref("")
const isDepartmentNmCompanyRankNmErrorType= ref("")
const isTelErrorInputType                 = ref("")

let hcasSsoIntlYn = "N";  //HCAS SSO연동여부
let hcasClntCd    ="";    //HCAS 고객사코드

defineProps({
  name: {
    type: String,
    default: ''
  },
})

const {
  showAlert,
  showConfirm
} = usePopup()

//init 함수
onMounted(async () => {
  if(useHconAuthInfo().getIfPossible() != null && useHconAuthInfo().getIfPossible()?.userContext.userKey != "" ){
    useRouter().push('/');
  }

  //HCAS SSO연동여부
  if('Y' == useRoute().query.hcasSsoIntlYn){
    hcasSsoIntlYn = 'Y';
    hcasClntCd = useRoute().query.hcasClntCd as string; //고객사코드
  }

  fetchBuilder.post<AjaxResult<BizcBiztpDto[][]>>('/api/v1/member/join/get-bizcBiztp')
      .body({
        hcBizcCd : ""
      })
      .progressMessage("잠시만 기다려주세요...")
      .build().execute()
  .then((result) => {

    const bizcDataList = result.data[0].map( item => {
      return {
        key   : item.hcBizcCd,
        value : item.hcBizcNm,
      }
    });

    bizcList.splice(0,bizcList.length, ...bizcDataList);
  });

  fetchBuilder.get<AjaxResult<{hc_usr_dept_cd : CodeDto[] }>>('/api/v1/common/codes/hc_usr_dept_cd')
  .build()
  .execute()
  .then((result) => {

    const deptDataList = result.data.hc_usr_dept_cd.map( item => {
      return {
        key   : item.commDtlCd,
        value : item.commDtlCdNm,
      }
    });

    deptList.splice(0,deptList.length, ...deptDataList);
    deptList.sort((a,b) => a.key - b.key)
  });

  fetchBuilder.get<AjaxResult<{hc_usr_jrsp_cd : CodeDto[] }>>('/api/v1/common/codes/hc_usr_jrsp_cd')
  .build()
  .execute()
  .then((result) => {

    const jrspDataList = result.data.hc_usr_jrsp_cd.map( item => {
      return {
        key   : item.commDtlCd,
        value : item.commDtlCdNm,
      }
    });

    jrspList.splice(0,jrspList.length, ...jrspDataList);
    jrspList.sort((a,b) => a.key - b.key)
  });


  fetchBuilder.get<AjaxResult<{hc_area_no_cd : CodeDto[] }>>('/api/v1/common/codes/hc_area_no_cd')
  .build()
  .execute()
  .then((result) => {

    const areaNoDataList = result.data.hc_area_no_cd.map( item => {
      return {
        key   : item.commDtlCd,
        value : item.commDtlCdNm,
      }
    });

    areaNoList.splice(0,areaNoList.length, ...areaNoDataList);
    areaNoList.sort((a,b) => a.key - b.key)
  });


  CommonUtil.fetchBuild.terms(HcTncUsePntmCd.MEMBER_JOIN).execute()
  .then((result) => {
    if(result.resultCode != '200') {
        showAlert(result.resultMessage);
      } else {
        tncList.value = result.data;
        tncNo1001.value = tncList.value.find((v: { hcTncKndCd: string }) => v.hcTncKndCd == '1001').tncNo
        tncNo1006.value = tncList.value.find((v: { hcTncKndCd: string }) => v.hcTncKndCd == '1006').tncNo
        tncNo1011.value = tncList.value.find((v: { hcTncKndCd: string }) => v.hcTncKndCd == '1011').tncNo
        // tncNo1012.value = tncList.value.find((v: { hcTncKndCd: string }) => v.hcTncKndCd == '1012').tncNo
      }
  });

})
//업태 콤보박스 값 변동에 따른 리스트 제어
watch(dropDownBizc, (newBizc, ) => {
  if (newBizc === 'Z') {
    if(biztpList.length < 1) {biztpList.unshift({key : '999999', value : '기타'})}
      isShowBizc.value          = true
      isShowBiztp.value         = true
      dropDownBiztp.value       = '999999'
      isShowBizcBiztpHelp.value = true
  } else {
      isShowBizc.value          = false
      isShowBiztp.value         = false
      inputBizc.value           = ''
      inputBiztp.value          = ''
      dropDownBiztp.value       = ''
      isShowBizcBiztpHelp.value = false

    fetchBuilder.post<AjaxResult<BizcBiztpDto[][]>>('/api/v1/member/join/get-bizcBiztp')
      .body({
        hcBizcCd : newBizc
      })
      .progressMessage("잠시만 기다려주세요...")
      .build().execute()
      .then((result) => {
        biztpList.length = 0;

        const biztpDataList = result.data[0].map( item => {
          return {
            key      : item.hcBiztpCd,
            value    : item.hcBiztpNm
          }
        });
        biztpList.splice(0,biztpList.length, ...biztpDataList);
      })

      // if(isShowMain.value == true) inputBizc.value = newBizc;
      // if(isShowMain2.value == true) inputBizc2.value = newBizc;
  }
})


//업종 콤보박스 값 변동에 따른 리스트 제어
watch(dropDownBiztp, (newBiztp, ) => {

  if (newBiztp === '999999') {
    isShowBiztp.value = true
  } else {
      isShowBiztp.value = false
      inputBiztp.value  = ''
  }
})
//업태 콤보박스 값 변동에 따른 리스트 제어
watch(dropDownBizc2, (newBizc, ) => {
  if (newBizc === 'Z') {
    if(biztpList.length < 1) {biztpList.unshift({key : '999999', value : '기타'})}
      isShowBizc2.value          = true
      isShowBiztp2.value         = true
      dropDownBiztp2.value       = '999999'
      isShowBizcBiztpHelp2.value = true
  } else {
      isShowBizc2.value          = false
      isShowBiztp2.value         = false
      inputBizc2.value           = ''
      inputBiztp2.value          = ''
      dropDownBiztp2.value       = ''
      isShowBizcBiztpHelp2.value = false

    fetchBuilder.post<AjaxResult<BizcBiztpDto[][]>>('/api/v1/member/join/get-bizcBiztp')
      .body({
        hcBizcCd : newBizc
      })
      .progressMessage("잠시만 기다려주세요...")
      .build().execute()
      .then((result) => {
        biztpList.length = 0;

        const biztpDataList = result.data[0].map( item => {
          return {
            key      : item.hcBiztpCd,
            value    : item.hcBiztpNm
          }
        });
        biztpList.splice(0,biztpList.length, ...biztpDataList);
      })

      // if(isShowMain.value == true) inputBizc.value = newBizc;
      // if(isShowMain2.value == true) inputBizc2.value = newBizc;
  }
})


//업종 콤보박스 값 변동에 따른 리스트 제어
watch(dropDownBiztp2, (newBiztp, ) => {

  if (newBiztp === '999999') {
    isShowBiztp2.value = true
  } else {
      isShowBiztp2.value = false
      inputBiztp2.value  = ''
  }
})
//전화번호 <-> 담당자명 삭제 시 초기화 제어
watch([inputMblTelno, inputChrgrNm], (newValues, ) => {
  const [newMblTelno, newChrgrNm] = newValues;

  if(HconCommonUtils.isEmpty(newMblTelno)) {
    inputChrgrNm.value = ''
  }

  if(HconCommonUtils.isEmpty(newChrgrNm)) {
    inputMblTelno.value = ''
  }
})

//근무부서 콤보박스 값 변동에 따른 리스트 제어
watch(dropDownDept, (newDept, ) => {
  if (newDept === '1008') {
    isShowDept.value          = true
    isShowJrsp.value          = true
    dropDownJrsp.value        = '9999'
    isShowDeptJrspHelp.value  = true
  } else {
    isShowDept.value          = false
    isShowJrsp.value          = false
    inputDept.value           = ''
    inputJrsp.value           = ''
    dropDownJrsp.value        = ''
    isShowDeptJrspHelp.value  = false
  }
})

//직급 콤보박스 값 변동에 따른 리스트 제어
watch(dropDownJrsp, (newJrsp, ) => {
  if (newJrsp === '9999') {
    isShowJrsp.value = true
  } else {
    isShowJrsp.value = false
    inputJrsp.value  = ''
  }
})

watch(inputId , (newV, oldV) => {
  duplicatedIdFlag.value = false;
  spanClass2.value = "icon-check off";
})

watch(inputEmlAdr , (newV, oldV) => {
  duplicatedEmailFlag.value = false;
  spanClass2.value = "icon-check off";
})

watch(checkMblTelnoFlag, (newV, ) => {
  if(newV && duplicatedIdFlag.value && duplicatedEmailFlag.value) spanClass2.value = "icon-check on";
})

watch(duplicatedIdFlag, (newV, ) => {
  if(checkMblTelnoFlag.value && newV && duplicatedEmailFlag.value) spanClass2.value = "icon-check on";
})

watch(duplicatedEmailFlag, (newV, ) => {
  if(checkMblTelnoFlag.value && duplicatedIdFlag.value && newV) spanClass2.value = "icon-check on";
})

const changeShow = () => {
  fetchLoading.value  = true;
  isShowMain.value    = !isShowMain.value;
  isShowMain2.value   = !isShowMain2.value;
  fetchLoading.value  = false;
  spanClass.value     = "icon-check off";

  if(isShowMain.value) {
    inputBzcoNm2.value    = inputBzcoNm.value;
    inputBzrn2.value      = inputBzrn.value;
    inputBzcoNm.value    = inputBzcoNm2.value;
    inputBzrn.value      = inputBzrn2.value;
    inputBzcoRgcrt.value  = '';
    inputRpsrNm2.value    = '';
    inputBizc2.value      = '';
    inputBiztp2.value     = '';
    inputBzcoAdr2.value   = '';
  } else {
    inputBzcoNm2.value    = inputBzcoNm.value;
    inputBzrn2.value      = inputBzrn.value;
    inputBzcoNm.value    = inputBzcoNm2.value;
    inputBzrn.value      = inputBzrn2.value;
  }
}


const onChangeBzcoRgcrt = (uploadedFiles: CommonFile[]) => {
  bzcoRgcrt.value = uploadedFiles;
  // status 값 체크
  const chkStatus = uploadedFiles.filter(file => file.status === 'STORED') // 실제
  // const chkStatus = uploadedFiles.filter(file => file.status === 'STORED' || file.status === 'ERROR') // 테스트 코드 
  if(uploadedFiles[0]) {
    filePlaceholder.value = uploadedFiles[0].name;
    fileUploadFlag.value = true;
    inputBzcoRgcrt.value = uploadedFiles[0].name;
  }
  // temp 정상인 경우 Upload
  // if(chkStatus.length > 0) {
  //   uploadBzcoRgcrt();
  // }
}


// 이미지 등록
const uploadBzcoRgcrt = async () => {

// API 호출
const fetchBuilderResult = 
fetchBuilder.post<AjaxResult<CommFileDto>>('/api/v1/common/file-upload')
.body({
    userKey: useHconAuthInfo().getIfPossible()?.userContext.userKey, 
    subject: "bzco",
    store: "contents",
    file: bzcoRgcrt.value?.[0] ?? null
  })
.build()
.execute()
.then(async (result) => {
  if(result.resultCode != '200') {
    showAlert({
      title: '알림',
      message: result.resultMessage,
      confirmText: '확인'
    })
     return false;
  } else {
    // 정상인 경우 - DB처리
    if((result.data.file.id !== null && result.data.file.id.length > 0)
        && (result.data.file.name !== null && result.data.file.name.length > 0)) {

          inputBzcoRgcrt.value = result.data.file.name;
          await nextTick();
          atchFilePath.value = result.data.file.id;
          await nextTick();
          registMember()
       // createBzcoRgcrt(result.data)
    } else {
      showAlert({
        title: '알림',
        message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9157),
        confirmText: '확인'
      })

      return false;
    }
  }
})

return true;
}

const handleBusinessPopup = async () => {  
  const result = await showConfirm({
    title: '사업자 정보 확인 불가',
    message: MEMBER_CODE.ALT_HCON_9038,
    confirmText: '직접입력',
    cancelText: '취소'
  })

  if (result) changeShow()
}

const checkBzno = async () => {
  if(fetchLoading.value) return
  //상호(회사명) 유효성 검사
  if(HconCommonUtils.isEmpty(inputBzcoNm.value)) {
    showAlert({
      message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "상호(회사명)를", "입력"),
      onConfirm: () => {  inputBzcoNmRef?.value?.onInputTextFocus();
      }
    }); 
    return false;
  }

  if(HconCommonUtils.isEmpty(inputRpsrNm.value)) {
    showAlert({
      message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "대표자명을", "입력"),
      onConfirm: () => {  inputRpsrNmRef?.value?.onInputTextFocus();
      }
    }); 
    return false;
  }

  //사업자등록번호 유효성 검사
  if(HconCommonUtils.isEmpty(inputBzrn?.value)) {
    showAlert({
      message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "사업자등록번호를", "입력"),
      onConfirm: () => { inputBzrnRef?.value?.onNumberFocus();
      }
    }); 
    return false;
  }

  if(inputBzrn?.value?.length < 10) {
    showAlert({
      message : MEMBER_CODE.ALT_HCON_9028,
      onConfirm: () => { inputBzrnRef?.value?.onNumberFocus();
      }
    }); 
    return false;
  }

try {
  fetchLoading.value = true;
  await fetchBuilder.post<AjaxResult<any>>('/api/v1/certificate/certificate-bzno')
  .body({
    id:       "",                     //회원사 ID
    srvNo:    "",                  //서비스 번호
    reqNum:   "",                 //요청번호
    bzNo:     inputBzrn?.value,     //사업자번호
    coNo:     "",                   //법인번호
    enpNm:    inputBzcoNm?.value,  //사업자명
    retUrl:   "",
    rpsrNm:   inputRpsrNm?.value
  })
  .progressMessage("진행 중입니다.")
  .build()
  .execute()  
  .then(async (result) => {
        if(result.resultCode == "200") {
          const strResult = result.data;

          if(strResult == "11" || strResult == "12" || strResult == "13") {
            showAlert({
              message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9004, "사업자등록번호 인증이")
            }); 

            checkBznoFlag.value = true
            spanClass.value = "icon-check on";
          } else if (strResult == "21" || strResult == "22" || strResult == "23") {
            const result = await showConfirm({
              title: '사업자 정보 확인 불가',
              message : HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9031),
              confirmText: '직접입력',
              cancelText: '취소'
            })

            if (result) changeShow()

            checkBznoFlag.value = false
            spanClass.value = "icon-check off";
            return false;
          } else if (strResult == "30") {
            const result = await showConfirm({
              title: '사업자 정보 확인 불가',
              message : "자료없음 - KED 및 SCI DB에 없음",
              confirmText: '직접입력',
              cancelText: '취소'
            })

            if (result) changeShow()

            checkBznoFlag.value = false
            spanClass.value = "icon-check off";
            return false;
          }
          else if (strResult == "40") {
            const result = await showConfirm({
              title: '사업자 정보 확인 불가',
              message : "등록번호 조합오류 - 사업자번호 자릿수 및 숫자여부체크",
              confirmText: '직접입력',
              cancelText: '취소'
            })

            if (result) changeShow()

            checkBznoFlag.value = false
            spanClass.value = "icon-check off";
            return false;
          }
          else if (strResult == "50") {
            const result = await showConfirm({
              title: '사업자 정보 확인 불가',
              message : "시스템장애 - SCI 시스템 및 KED연동 장애",
              confirmText: '직접입력',
              cancelText: '취소'
            })
            
            if (result) changeShow()

            checkBznoFlag.value = false
            spanClass.value = "icon-check off";
            return false;
          }
        }
      });
  //   const mappedData = result?.data
  //   /*         
  //   * 실명확인 결과값
  //   * 11 : 일치 - 사업자번호 법인번호 업체명 모두 일치 O
  //   * 12 : 일치 - 사업자번호와 업체명 일치, 법인번호 미입력
  //   * 13 : 일치 - 사업자번호와 업체명 일치, 사업자번호와 법인번호 불일치
  //   * 21 : 불일치 - 사업자번호와 업체명 불일치, 사업자번호와 법인번호 일치
  //   * 22 : 불일치 - 사업자번호와 업체명 불일치, 법인번호 미입력
  //   * 23 : 불일치 - 사업자번호와 업체명 뷸일치, 사업자번호와 법인번호 불일치
  //   * 30 : 자료없음 - KED 및 SCI DB에 없음.
  //   * 40 : 등록번호 조합오류 - 사업자번호, 법인번호 자릿수 및 숫자여부체크
  //   * 50 : 시스템장애 - SCI 시스템 및 KED연동 장애
  //   */
  //  if(mappedData?.result == '11' || mappedData?.result == '12' || mappedData?.result == '13') {
  //     showAlert('인증성공입니다.');
  //     spanClass.value = "icon-check on";
  //     checkBznoFlag.value = true;
  //     // navigateTo({
  //     // path: '/pc/member/login/password-reset',
  //     // query: { 
        
  //     // },
  //     // }, {external: false});
  //   } else if (mappedData?.result == '30') {
  //     handleBusinessPopup();
  //   } else if (mappedData?.result == '50') {
  //     showAlert(MEMBER_CODE.ALT_HCON_9031);
  //     return false;
  //   }else {
  //     showAlert(MEMBER_CODE.ALT_HCON_9029);
  //     return false;
  //   }
    } catch (err) {
    console.error(err)
  } finally {
    // 작업중 해제
    fetchLoading.value = false;
  }
}

const checkMblTelno = () => {

  fetchBuilder
    .get<AjaxResult<any>>("/api/v1/certificate/get-certificate-url")
    .query()
    .build()
    .execute()
    .then((result) => {
     sessionStorage.setItem('common.auth.transaction_id', result.data.transaction_id)
     const popup = window.open(result.data.auth_url,'popupPhoneCert','width=600, height=1110, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no')
     window.addEventListener("message", (event) => {
      if(event.data.returnCode == "0000") {
        showAlert({
        message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9004, "휴대전화번호 인증이"),
        });

        inputEncCi.value = event.data.authResultData.ci
        inputMblTelno.value = event.data.authResultData.mobile_no
        inputChrgrNm.value = event.data.authResultData.name
        inputSelfCrtfGndrNval.value = event.data.authResultData.gender
        inputBirth.value = event.data.authResultData.birthdate
        checkMblTelnoFlag.value = true;
      } else {
        showAlert({
        message : MEMBER_CODE.ALT_HCON_9034
        });

        return false;
      }
     })
     
     if(popup === null || typeof popup ==='undefined'){
        alert('브라우저에서 팝업이 차단되었습니다. 팝업 차단을 해제해주세요.');
      }else{
        popup.focus();
      }

      //   const popup = window.open('about:blank','popupPhoneCert','width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no')
    });
};

//회원정보 중복 확인 (아이디, 이메일)
const checkDuplicatedMemberInfo = (infoValue : String) => {

  //아이디 중복 확인
  if(infoValue == 'id') if(!validateId()) return false;

  //이메일 중복 확인
  if(infoValue == 'email') if(!inputEmlAdrRef.value?.onEmailAdrValidate(true)) return false;


  fetchBuilder.post<AjaxResult<MemberInfoDuplicateCheckDto>>('/api/v1/member/join/check-duplicated-memberInfo/' + infoValue)
  .body({
    hcUsrId: inputId?.value,
    emlAdr: inputEmlAdr?.value
  })
  .progressMessage("잠시만 기다려주세요...")
  .build()
  .execute()
  .then((result) => {
    if(result?.data.duplicatedYn == 'Y') {
      if(infoValue == 'id'){
        showAlert({
        message : MEMBER_CODE.ALT_HCON_9013,
        onConfirm: () => {  inputIdRef.value?.onInputTextFocus();
        }
        }); 
      } 
      
      if(infoValue == 'email'){
        showAlert({
        message : MEMBER_CODE.ALT_HCON_9035,
        onConfirm: () => {  inputEmlAdrRef.value?.onInputTextFocus();
        }
        }); 
      } 
    }

    if(result?.data.duplicatedYn == 'N') {
      if(infoValue == 'id'){
        duplicatedIdFlag.value = true;
        showAlert({
          message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9004, "아이디 중복확인"),
          onConfirm: () => {  
          }
        });
      }

      if(infoValue == 'email'){
        duplicatedEmailFlag.value = true;
        showAlert({
          message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9004, "이메일 중복확인"),
          onConfirm: () => {  
          }
        });
      }
    } 
    
  })
}

const validateId = () =>  {
  //null 체크
  if(HconCommonUtils.isEmpty(inputId?.value)) {
    showAlert({
      message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "아이디를", "입력"),
      onConfirm: () => {  inputIdRef.value?.onInputTextFocus();
      }
    }); 
    return false;
  }
  //아이디 패턴 체크 (소문자+숫자)
  if(!HconCommonRegExp.user_id_regex.test(inputId?.value)) {
    showAlert({
      message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9008, "아이디"),
      onConfirm: () => {  inputIdRef.value?.onInputTextFocus();
      }
    }); 
    return false;
  }

  return true;
}

const checkBoxAllChanged = (isChecked : boolean) => { 
  checkBoxAllChecked.value = isChecked ? 'Y' :'N' 
  if(checkBoxAllChecked.value == 'Y')
  {
    checkBoxOver14Checked.value = 'Y'
    checkBox1001Checked.value = 'Y'
    checkBox1006Checked.value = 'Y'
    checkBox1011Checked.value = 'Y'
    checkBoxSns1001Checked.value = 'Y'
    checkBoxSns1002Checked.value = 'Y'
  }

  if(checkBoxAllChecked.value == 'N')
  {
    checkBoxOver14Checked.value = 'N'
    checkBox1001Checked.value = 'N'
    checkBox1006Checked.value = 'N'
    checkBox1011Checked.value = 'N'
    checkBoxSns1001Checked.value = 'N'
    checkBoxSns1002Checked.value = 'N'
  }
}
const checkBoxOver14Changed = (isChecked : boolean) => { checkBoxOver14Checked.value= isChecked ? 'Y' :'N' }
const checkBox1001Changed = (isChecked : boolean) => { checkBox1001Checked.value= isChecked ? 'Y' :'N' }
const checkBox1006Changed = (isChecked : boolean) => { checkBox1006Checked.value= isChecked ? 'Y' :'N' }
const checkBox1011Changed = (isChecked : boolean) => { 
  checkBox1011Checked.value= isChecked ? 'Y' :'N' 
  if(checkBox1011Checked.value == 'Y')
  {
    checkBoxSns1001Checked.value = 'Y'
    checkBoxSns1002Checked.value = 'Y'
  }
  if(checkBox1011Checked.value == 'N')
  {
    checkBoxSns1001Checked.value = 'N'
    checkBoxSns1002Checked.value = 'N'
  }
}
const checkBoxSns1001Changed = (isChecked : boolean) => { checkBoxSns1001Checked.value= isChecked ? 'Y' :'N' }
const checkBoxSns1002Changed = (isChecked : boolean) => { checkBoxSns1002Checked.value= isChecked ? 'Y' :'N' }

const onNumInput = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const cleanedValue = target.value.replace(/[^0-9]/g, '');

  inputMblTelno.value =  cleanedValue
}

const validateFlag = async () => {
  //사업자등록번호 인증 완료 확인
  if(isShowMain.value) {
    if(checkBznoFlag.value == false) {
      showAlert({
        message : HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9105),
        onConfirm: () => { 
        }
      });
      return false;
    }
  } else {
    checkBznoFlag.value = true
  }

  //아이디 중복 확인 완료 확인
  if(duplicatedIdFlag.value == false) {
    showAlert({
      message : MEMBER_CODE.ALT_HCON_9106,
      onConfirm: () => {  
      }
    });
    return false;
  }

  //이메일 중복 확인 완료 확인
  if(duplicatedEmailFlag.value == false) {
    showAlert({
      message : MEMBER_CODE.ALT_HCON_9108,
      onConfirm: () => {  
      }
    });
    return false;
  }
  
    //PASS 인증 완료 확인
  if(checkMblTelnoFlag.value == false) {
    showAlert({
      message : MEMBER_CODE.ALT_HCON_9107,
      onConfirm: () => {  
      }
    });
    return false;
  }

  if(checkBznoFlag.value == true && checkMblTelnoFlag.value == true && duplicatedIdFlag.value == true && duplicatedEmailFlag.value == true) {
    return true;
  } else {
    return false;
  }
}

const validateBizInfo = async () => {
  const validInputBzcoNm      = ref("")
  const validInputBzcoNmRef   = ref<InstanceType<typeof HconInput> | null>(null)
  const validInputBzrn        = ref("")
  const validInputBzrnRef     = ref<InstanceType<typeof HconInput> | null>(null)
  const validInputRpsrNm      = ref("")
  const validInputRpsrNmRef   = ref<InstanceType<typeof HconInput> | null>(null)
  const validInputBizc        = ref("")
  const validInputBizcRef     = ref<InstanceType<typeof HconInput> | null>(null)
  const validDropDownBizc     = ref("")
  const validInputBiztp       = ref("")
  const validInputBiztpRef    = ref<InstanceType<typeof HconInput> | null>(null)
  const validDropDownBiztp    = ref("")
  const validInputBzcoAdr     = ref("")
  const validInputBzcoAdrRef  = ref<InstanceType<typeof HconInput> | null>(null)

  if(isShowMain.value) {
    validInputBzcoNm.value      = inputBzcoNm?.value;
    validInputBzcoNmRef.value   = inputBzcoNmRef.value;
    validInputBzrn.value        = inputBzrn?.value;
    validInputBzrnRef.value     = inputBzrnRef.value;
    validInputRpsrNm.value      = inputRpsrNm?.value;
    validInputRpsrNmRef.value   = inputRpsrNmRef.value;
    validInputBizc.value        = dropDownBizc?.value;
    validInputBizcRef.value     = inputBizcRef.value;
    validDropDownBizc.value     = dropDownBizc.value;
    validInputBiztp.value       = inputBiztp?.value;
    validInputBiztpRef.value    = inputBiztpRef.value;
    validDropDownBiztp.value    = dropDownBiztp.value;
    validInputBzcoAdr.value     = inputBzcoAdr?.value;
    validInputBzcoAdrRef.value  = inputBzcoAdrRef.value;
  } else {
    validInputBzcoNm.value      = inputBzcoNm2?.value;
    validInputBzcoNmRef.value   = inputBzcoNm2Ref.value;
    validInputBzrn.value        = inputBzrn2?.value;
    validInputBzrnRef.value     = inputBzrn2Ref.value;
    validInputRpsrNm.value      = inputRpsrNm2?.value;
    validInputRpsrNmRef.value   = inputRpsrNm2Ref.value;
    validInputBizc.value        = inputBizc2?.value;
    validInputBizcRef.value     = inputBizc2Ref.value;
    validDropDownBizc.value     = dropDownBizc2.value;
    validInputBiztp.value       = inputBiztp2?.value;
    validInputBiztpRef.value    = inputBiztp2Ref.value;
    validDropDownBiztp.value    = dropDownBiztp2.value;
    validInputBzcoAdr.value     = inputBzcoAdr2?.value;
    validInputBzcoAdrRef.value  = inputBzcoAdrRef.value;
  }

  //상호(회사명) 유효성 검사
  if(HconCommonUtils.isEmpty(validInputBzcoNm.value)) {
    showAlert({
      message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "상호(회사명)를", "입력"),
      onConfirm: () => {  validInputBzcoNmRef?.value?.onInputTextFocus();
      }
    }); 
    return false;
  }

  //사업자등록번호 유효성 검사
  if(HconCommonUtils.isEmpty(validInputBzrn.value)) {
    showAlert({
      message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "사업자등록번호를", "입력"),
      onConfirm: () => { validInputBzrnRef?.value?.onNumberFocus();
      }
    }); 
    return false;
  }

  if(validInputBzrn?.value?.length < 10) {
    showAlert({
      message : MEMBER_CODE.ALT_HCON_9028,
      onConfirm: () => { validInputBzrnRef?.value?.onNumberFocus();
      }
    }); 
    return false;
  }

      //사업자등록증 사본
  if(isShowMain2.value) { 
    if(HconCommonUtils.isEmpty(inputBzcoRgcrt?.value)) {
      showAlert({
        message : HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9006, "사업자등록증"),
        onConfirm: () => { inputBzcoRgcrtRef?.value?.onInputTextFocus();
        }
      }); 
      return false;
    }

    //사업자등록증 사본 파일형식, 용량
    if(HconCommonUtils.isEmpty(inputBzcoRgcrt?.value)) {
      showAlert({
        message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9007, "png, jpg, pdf", "2MB"),
        onConfirm: () => { inputBzcoRgcrtRef?.value?.onInputTextFocus();
        }
      }); 
      return false;
    }
  }

  //대표자명 유효성 검사
  if(HconCommonUtils.isEmpty(validInputRpsrNm?.value)) {
    showAlert({
      message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "대표자명을", "입력"),
      onConfirm: () => { validInputRpsrNmRef?.value?.onInputTextFocus();
      }
    }); 
    return false;
  }

  //업태/종목 유효성 검사
  if(HconCommonUtils.isEmpty(validDropDownBizc?.value) || HconCommonUtils.isEmpty(validDropDownBiztp?.value)) {
    showAlert({
      message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "업태와 종목을", "선택"),
      onConfirm: () => { 
      }
    }); 
    return false;
    }

    if(HconCommonUtils.isEmpty(validDropDownBizc?.value)) {
    showAlert({
      message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "업태를", "선택"),
      onConfirm: () => { 
      }
    }); 
    return false;
    }

    if(validDropDownBizc.value == 'Z' && HconCommonUtils.isEmpty(validInputBizc?.value)) {
      showAlert({
      message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "업태를", "입력"),
      onConfirm: () => { validInputBizcRef?.value?.onInputTextFocus();
      }
    }); 
    return false;
    }

    if(HconCommonUtils.isEmpty(validDropDownBiztp?.value)) {
    showAlert({
      message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "종목을", "선택"),
      onConfirm: () => { 
      }
    }); 
    return false;
    }

    if(validDropDownBiztp.value == '999999' && HconCommonUtils.isEmpty(validInputBiztp?.value)) {
      showAlert({
      message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "종목을", "입력"),
      onConfirm: () => { validInputBiztpRef?.value?.onInputTextFocus();
      }
    }); 
    return false;
    }

    if(HconCommonUtils.isEmpty(validInputBzcoAdr?.value)) {
    showAlert({
      message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "사업장 주소를", "입력"),
      onConfirm: () => { validInputBzcoAdrRef?.value?.onInputTextFocus();
      }
    }); 
    return false;
    }

  return true;
}

const validateMemberInfo = async () => {
  //1. 아이디 유효성 체크
  if(!validateId()) return false;

  //2. 비밀번호 유효성 체크

  // 비밀번호 null 체크
  if(HconCommonUtils.isEmpty(inputPassword?.value)) {
    showAlert({
      message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "비밀번호를", "입력"),
      onConfirm: () => { 
        inputPasswordRef.value?.onInputTextFocus();
      }
    });
    return false;
  } else {
    // 비밀번호 패턴 체크 (영문, 숫자, 특수문자 포함으로 9~20자리)
    if(!HconCommonRegExp.password_regex.test(inputPassword?.value)){
      showAlert({
      message : MEMBER_CODE.ALT_HCON_9020,
      onConfirm: () => { 
        inputPasswordRef.value?.onInputTextFocus();
      }
      });      
      return false;
    }
  
    // 비밀번호 패턴 체크 (연속된 숫자/문자, 동일한 문자 3회 이상 사용 불가능)
    if(!HconCommonRegExp.password_no_repeat_regex.test(inputPassword?.value) || !HconCommonRegExp.password_no_continuation_regex.test(inputPassword?.value)){
      showAlert({
      message : MEMBER_CODE.ALT_HCON_9021,
      onConfirm: () => { 
        inputPasswordRef.value?.onInputTextFocus();
      }
      });      
      return false;
    }
  }

  // 비밀번호 확인란 null 체크
  if(HconCommonUtils.isEmpty(inputPasswordCheck?.value)) {
    showAlert({
      message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "비밀번호 확인란을", "입력"),
      onConfirm: () => { 
        inputPasswordCheckRef.value?.onInputTextFocus();
      }
    }); 
    return false;
  } else {
    //비밀번호 확인란 값 비교
    if(inputPassword.value != inputPasswordCheck.value) {
      showAlert({
      message : MEMBER_CODE.ALT_HCON_9016,
      onConfirm: () => { 
        inputPasswordCheckRef.value?.onInputTextFocus();
      }
    });
    return false;     
    }
  }

  //3. 휴대전화번호 확인
  if(checkMblTelnoFlag.value == false) {
    showAlert({
      message : MEMBER_CODE.ALT_HCON_9107,
      onConfirm: () => {  
      }
    });
    return false;
  }

  //4.이메일 체크
  if(!inputEmlAdrRef.value?.onEmailAdrValidate(true)) return false;

  //5.근무부서/직급 유효성 체크
  
  //근무부서 & 직급 null 체크
  // if(HconCommonUtils.isEmpty(dropDownDept?.value) && HconCommonUtils.isEmpty(dropDownJrsp?.value)) {
  //   showAlert({
  //     message : MEMBER_CODE.ALT_HCON_9036,
  //     onConfirm: () => {  inputIdRef.value?.onInputTextFocus();
  //     }
  //   }); 
  //   return false;
  // }
  
  // if(HconCommonUtils.isEmpty(dropDownDept?.value)) {
  //   showAlert({
  //     message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "근무부서를", "선택"),
  //     onConfirm: () => {  
  //     }
  //   }); 
  //   return false;
  // }

  if(dropDownDept?.value == "1008" && HconCommonUtils.isEmpty(inputDept?.value)) {
    showAlert({
      message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "근무부서를", "입력"),
      onConfirm: () => {  inputDeptRef.value?.onInputTextFocus();
      }
    }); 
    return false;
  }

  // if(HconCommonUtils.isEmpty(dropDownJrsp?.value)) {
  //   showAlert({
  //     message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "직급을", "선택"),
  //     onConfirm: () => {
  //     }
  //   }); 
  //   return false;
  // }

  if(dropDownJrsp?.value == "9999" && HconCommonUtils.isEmpty(inputJrsp?.value)) {
    showAlert({
      message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "직급을", "입력"),
      onConfirm: () => {  inputJrspRef.value?.onInputTextFocus();
      }
    }); 
    return false;
  }
  if(inputCbleTelno.value){
    if(!inputCbleTelnoRef.value?.onCbleTelnoValidate(true)) return false;  
  }
  // if(isNaN(Number(inputCbleTelno.value.split('-')[0])) || isNaN(Number(inputCbleTelno.value.split('-')[1]))|| isNaN(Number(inputCbleTelno.value.split('-')[2]))) {
  //   showAlert({
  //     message : "유선 전화번호는 숫자만 입력 가능합니다.",
  //     onConfirm: () => {  inputJrspRef.value?.onInputTextFocus();
  //     }
  //   }); 
  // }

  return true;
}

const validateTermsAgreeInfo = async  () => {
  if(checkBoxOver14Checked.value == 'N' && checkBox1001Checked.value == 'N' && checkBox1006Checked.value == 'N') {
    showAlert({
      message : MEMBER_CODE.ALT_HCON_9109,
      onConfirm: () => { 
      }
    }); 
    return false;
  }

  //14세 이상
  if(checkBoxOver14Checked.value == 'N') {
    showAlert({
      message : MEMBER_CODE.ALT_HCON_9033,
      onConfirm: () => { 
      }
    }); 
    return false;
  }

  //서비스이용약관
  if(checkBox1001Checked.value == 'N') {
    showAlert({
      message : MEMBER_CODE.ALT_HCON_9110,
      onConfirm: () => { 
      }
    }); 
    return false;
  }

  //개인정보수집
  if(checkBox1006Checked.value == 'N') {
    showAlert({
      message : MEMBER_CODE.ALT_HCON_9111,
      onConfirm: () => {  
      }
    }); 
    return false;
  }

  //마케팅정보수집
  if(checkBox1011Checked.value == 'Y') {
    if(checkBoxSns1001Checked.value == 'N' && checkBoxSns1002Checked.value == 'N') {
      showAlert({
      message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "문자알림 혹은 알림톡 중 하나를 필수로", "선택"),
      onConfirm: () => {  
      }
    }); 
    return false;
    }
  }

  return true;
}

const registMember  = async () => {
  console.log("### HCAS SSO연동여부: "+hcasSsoIntlYn);
  console.log("### HCAS 고객사코드: "+hcasClntCd);

  const vBiz = await validateBizInfo();
  if (!vBiz) return false;
  const vMem = await validateMemberInfo();
  if (!vMem) return false;
  const vTerm = await validateTermsAgreeInfo();
  if (!vTerm) return false;
  const vFlag = await validateFlag();
  if (!vFlag) return false;

  let lHcAreaNoCd = inputCbleTelno?.value.split('-')[0]
  let lUsrInsrAreaNoNm = ""
  let lCbleTelno = ""
  if(inputCbleTelno.value){
    if(lHcAreaNoCd == "999"){
      lUsrInsrAreaNoNm = inputCbleTelno?.value.split('-')[1]
      lCbleTelno = inputCbleTelno?.value.split('-')[2] + inputCbleTelno?.value.split('-')[3]
    } else {
      lUsrInsrAreaNoNm = ""
      lCbleTelno = inputCbleTelno?.value.split('-')[1] + inputCbleTelno?.value.split('-')[2]
    }
  }
  await fetchBuilder.post<AjaxResult<MemberInfoDuplicateCheckDto>>('/api/v1/member/join/create-hcon-memeberInfo')
  .body({
    bzcoNm: isShowMain.value==true?inputBzcoNm?.value:inputBzcoNm2?.value,
    bzrn: isShowMain.value==true?inputBzrn?.value:inputBzrn2?.value,
    rpsrNm: isShowMain.value==true?inputRpsrNm?.value:inputRpsrNm2?.value,
    atchFileNm: inputBzcoRgcrt.value,
    atchFilePath: atchFilePath.value,
    hcBizcCd: isShowMain.value==true?dropDownBizc?.value:dropDownBizc2?.value,
    usrInsrBizcNm: isShowMain.value==true?inputBizc?.value:inputBizc2?.value,
    hcBiztpCd: isShowMain.value==true?dropDownBiztp?.value:dropDownBiztp2?.value,
    usrInsrBiztpNm: isShowMain.value==true?inputBiztp?.value:inputBiztp2?.value,
    zipcd: "",
    basAdr: isShowMain.value==true?inputBzcoAdr?.value:inputBzcoAdr2?.value,
    dtlAdr: "",
    hcUsrId: inputId?.value,
    hcUsrPwd: inputPassword?.value,
    hcUsrMblTelno: inputMblTelno?.value.replaceAll('-',''),
    hcUsrNm: inputChrgrNm?.value,
    emlAdr: inputEmlAdr?.value,
    hcUsrDeptCd: dropDownDept?.value,
    usrInsrDetpNm: inputDept?.value,
    hcUsrJrspCd: dropDownJrsp?.value,
    usrInsrJrspNm: inputJrsp?.value,
    // hcAreaNoCd: inputCbleTelno?.value.areaCode,
    // cbleTelno: inputCbleTelno?.value.mid + inputCbleTelno?.value.last,
    hcAreaNoCd: lHcAreaNoCd,
    usrInsrAreaNoNm : lUsrInsrAreaNoNm,
    cbleTelno: lCbleTelno,
    term1012Yn: checkBoxOver14Checked.value,
    tncNo1012 : tncNo1012.value!==""?tncNo1012.value:"1012",
    term1001Yn: checkBox1001Checked.value,
    tncNo1001 : tncNo1001.value!==""?tncNo1001.value:"1001",
    term1006Yn: checkBox1006Checked.value,
    tncNo1006 : tncNo1006.value!==""?tncNo1006.value:"1006",
    term1011Yn: checkBox1011Checked.value,
    tncNo1011 : tncNo1011.value!==""?tncNo1011.value:"1011",
    arai1001Yn: checkBoxSns1001Checked.value,
    arai1002Yn: checkBoxSns1002Checked.value,
    hcUsrStCd : isShowMain.value?'1001':'1004',
    usrEncCi: inputEncCi.value,
    selfCrtfGndrNval : inputSelfCrtfGndrNval.value,
    hcasSsoIntlYn: hcasSsoIntlYn,
    hcasClntCd: hcasClntCd,
    usrBirth: inputBirth.value
  })
  .build()
  .execute()
  .then((result) => {
    if(result.resultCode == '200'){
      if(isShowMain.value) {
        location.href = "/pc/member/join/join-complete";
      } else if(isShowMain2.value) {
        location.href = "/pc/member/join/approval-request-complete";
      }
    }
  })
  .catch((error) => {
      // 응답코드가 200이 아닌경우
      if(error.resultCode != 200) {
        showAlert(error.resultMessage);
      }
    })
}


const showTermPop = ( cd : string ) => {
  const termUrl = tncList.value.find((v: { hcTncKndCd: string }) => v.hcTncKndCd == cd).tncPageUrl
  window.open(termUrl, '_blank');
}

</script>
<style lang="scss" scoped>
  
</style>